// Helper function to get auth headers
export function getAuthHeaders(): Record<string, string> {
  const token = localStorage.getItem('authToken');
  return token ? { 'Authorization': `Bearer ${token}` } : {};
}

// Helper function to check if user is logged in
export function isLoggedIn(): boolean {
  const token = localStorage.getItem('authToken');
  return !!token;
}

// Helper function to clear auth data
export function clearAuthData(): void {
  localStorage.removeItem('authToken');
}

// Helper function to set auth data
export function setAuthData(token: string): void {
  localStorage.setItem('authToken', token);
} 